import { mapOtsAvailability } from "@novelist/novum-novella-ui";
import SearchByLexileRangeUrl from "../../lib/titleSearch/lexileSearch/SearchByLexileRangeUrl";
import { performJsonpGetRequest } from "../../lib/HttpRequest";
import * as utility from "../../utility";
import { getOtsAvailabilityForResults } from "../OtsRequests";
import * as catalogUtility from "../../lib/CatalogLinkUtilities";

const lexileCallbackName = "lexileDataRetrievedCallback";

const translateLexileToNovumData = (min, max, titles) => {
	return {
		min: min,
		max: max,
		titles: titles
	};
};

const lexilePostAction = (min, max, data, finalCallback) => {
	let titles = data.Titles.map((title) => {
		return {
			ui: title.ui,
			mainTitle: title.full_title,
			author: title.full_author,
			bookjacketUrl: title.bookjacket_url ? title.bookjacket_url.url : null,
			catalogLinkUrl: title.is_held_locally === false ? null : catalogUtility.getTitleCatalogLink(title.links),
			description: title.description,
			isHeld: title.is_held_locally,
			availability: undefined
		};
	});

	if(titles){
		finalCallback(translateLexileToNovumData(min, max, titles));
	}
	if (titles.length > 0) {
		if (data.OtsResultRelativeUrl) {
			Promise.resolve(getOtsAvailabilityForResults(data))
				.then((value) => {
					titles.map((item) => {
						let otsDataForTitle =
							value &&
							value.find((titleOts) => {
								return titleOts.key === item.ui;
							});
						item.availability = mapOtsAvailability(otsDataForTitle);
					});
					finalCallback(translateLexileToNovumData(min, max, titles));
				})
				.catch((err) => {
					finalCallback(translateLexileToNovumData(min, max, titles));
				});
		}
	}
};

export const getLexileSearchData = (min, max, audienceLevel, finalCallback) => {
	let searchByLexileRange = new SearchByLexileRangeUrl(
		{ lowerLexileScore: min, upperLexileScore: max },
		audienceLevel
	);
	let apiEndpoint = searchByLexileRange.generateUrl();

	let callback = (data) => {
		lexilePostAction(min, max, data, finalCallback);
	};

	utility.attachFunctionToCallback(callback, lexileCallbackName);

	performJsonpGetRequest(apiEndpoint, lexileCallbackName);
};



// WEBPACK FOOTER //
// ./src/data/services/LexileRangeService.js